import Nav from './src/Nav';

export default Nav;
